import React, { useState, useEffect } from 'react';

import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { useLocation } from "react-router-dom";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import Section from '../Section';
import { getSqrContentData } from '../../server/ServerFunc';
import SvgIcon from '../../CustomeComponents/SvgIcon';
import AppFooter from '../AppFooter';
import AppHeaderGlobal from '../AppHeaderGlobal';

const AreasInfo = ({ isSeparate }) => {
  const [sqrList, setSqrList] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  const search = useLocation().search;

  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum");
    const systemCodeURL = new URLSearchParams(search).get("SystemCode");
    getSqrContent(systemCodeURL, tikNumURL);
    setIsMobile(window.innerWidth < 768);
  }, []);
  
  const getSqrContent = async (systemCode, tikNum) => { 
    const sqrData = await getSqrContentData(systemCode, tikNum);    

    if(sqrData.length > 0) {
      setSqrList(sqrData);
    } else {
      setSqrList([]);
    }
  }

	const titles = {
		"descrShetah": "תיאור",
		"kayam": "קיים",
		"tosefet": "תוספת",
		"sumSqr": "סה''כ"
	}

  const exportPDF_NG = () => {   
    // setTimeout(() => {
      // 1. Save Title as pdf
      const tikDataTitle = document.getElementById("tikToPrint");
      // console.log('tikDataTitle: ', tikDataTitle);
      const pdf = new jsPDF("p", "mm");

      html2canvas(tikDataTitle).then((canvasTitle) => {
        // console.log('canvasTitle', canvasTitle);
        const imgWidth = 190;
        const imgHeight = (canvasTitle.height * imgWidth) / canvasTitle.width;
        let positionY = 10;
        pdf.addImage(canvasTitle, "PNG", 10, positionY, imgWidth, imgHeight, "", "FAST");
      });
      
      //2. Save the table as pdf
      const tableData = document.getElementById("dataToPrint");
      // console.log("tableData: ", tableData);
      html2canvas(tableData).then((canvasTable) => {
        // console.log('canvasTable', canvasTable);
        const imgWidth = 200; //180
        const pageHeight = 295;
        const imgHeight = (canvasTable.height * imgWidth) / canvasTable.width;
        let heightLeft = imgHeight;
        let positionY = 10;
        heightLeft -= pageHeight;

        pdf.addImage(canvasTable, "PNG", 0, positionY + 10, imgWidth, imgHeight, "", "FAST");
        while (heightLeft >= 0) {
          positionY = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(canvasTable, "PNG", 0, positionY + 20, imgWidth, imgHeight, "", "FAST");
          heightLeft -= pageHeight;
        }

        pdf.save(`שטחים`);
      });
    // }, 1000);
  }

  const LabeledDataItem = (label, value, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			<div className="value">
        {
          field === "kayam" ? 
            (value === 0 ? "-" : value)
            :
            value
        }
      </div>
		</div>
	}

  const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

  const TableSqrList = () => {
		return (
        <div id="dataToPrint">
          <Grid data={sqrList} >
              {/* <GridToolbar> */}
                {/* MOBILE: marginRight: 300px;  */}
                {/* <SvgIcon icon={"download-doc"} title="ייצוא ל- PDF" onClick={exportPDF_NG} style={{ cursor: "pointer" }} />
              </GridToolbar> */}
              <GridColumn field="descrShetah" title={titles.descrShetah} cell={LabeledCell} />
              <GridColumn field="kayam" title={titles.kayam} cell={LabeledCell} />
              <GridColumn field="tosefet" title={titles.tosefet} cell={LabeledCell} />
              <GridColumn field="sumSqr" title={titles.sumSqr} cell={LabeledCell} />
          </Grid>
        </div>
		)
	}
  
  return (
    <>
      { isSeparate && <AppHeaderGlobal /> }
      <div style={{ margin: `${isMobile ? "-104px 0px 0px 0px" : (!isSeparate ? "-130px 0px 0px 0px" : "")}`, backgroundColor: "white" }} >
        <div className="container my-3 my-lg-5">
          {/* <SvgIcon icon={"download-doc"} title="ייצוא ל- PDF" onClick={exportPDF_NG} style={{ cursor: "pointer", marginLeft: "5px" }} /> */}
          {
            !isMobile ?
              <div>
                <SvgIcon icon={"download-doc"} title="ייצוא ל- PDF" onClick={exportPDF_NG} style={{ cursor: "pointer", marginLeft: "5px" }} />
                ייצוא ל- PDF
              </div>
              :
              ""
          }
          <Section icon={'hammer'} title={'שטחים'} className="mt-3">
            {
              sqrList.length > 0 ?
                <TableSqrList />
                :
                <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
            }
          </Section>
        </div>
      </div>
      { isSeparate && <AppFooter /> }
		</>
  )
}

export default AreasInfo;